<template>
  <!--
    Unfortunately, ReuseTemplate doesn't work with `addRecentlyVisited()` inside `HeaderSearchOverlay.vue`.
    Not sure why or how to fix it. So for now we copy-paste the template, which clutters this component.
    I'll leave it commented out, hoping for a fix in the future ¯\_(ツ)_/¯
  -->

  <!-- <DefineTemplate>
    <WaimoFlex
      justify="between"
      align="center"
      class="entity-item"
    >
      <slot name="indicator" />
      <WaimoFlex
        direction="column"
        gap="0"
        style="flex-grow: 1"
      >
        <span style="font-size: 1.2em; font-weight: 600">
          <slot />
        </span>
        <span class="dark-text-40">
          {{ subText }}
        </span>
      </WaimoFlex>
    </WaimoFlex>
  </DefineTemplate> -->

  <router-link
    v-if="to"
    :to="to"
  >
    <!-- <ReuseTemplate /> -->

    <WaimoFlex
      justify="between"
      align="center"
      :class="['entity-item', { 'entity-item--background': background }]"
    >
      <div class="entity-item__indicator">
        <slot name="indicator" />
      </div>
      <WaimoFlex
        direction="column"
        gap="0"
        style="flex-grow: 1"
      >
        <span style="font-size: 1.2em; font-weight: 600">
          <slot />
        </span>
        <span class="dark-text-40">
          {{ subText }}
        </span>
      </WaimoFlex>
    </WaimoFlex>
  </router-link>

  <div
    v-else
    @click="$emit('itemClicked')"
  >
    <!-- <ReuseTemplate /> -->

    <WaimoFlex
      justify="between"
      align="center"
      :class="['entity-item', { 'entity-item--background': background }]"
    >
      <div class="entity-item__indicator">
        <slot name="indicator" />
      </div>
      <WaimoFlex
        direction="column"
        gap="0"
        style="flex-grow: 1"
      >
        <span style="font-size: 1.2em; font-weight: 600">
          <slot />
        </span>
        <span class="dark-text-40">
          {{ subText }}
        </span>
      </WaimoFlex>
    </WaimoFlex>
  </div>
</template>

<script setup lang="ts">
import { WaimoFlex } from '@finetic/waimo-ui'
// import { createReusableTemplate } from '@vueuse/core'
import type { RouteLocationRaw } from 'vue-router'

withDefaults(
  defineProps<{
    to?: RouteLocationRaw
    subText?: string
    background?: boolean
  }>(),
  {
    to: undefined,
    subText: undefined,
    background: true,
  },
)

// const [DefineTemplate, ReuseTemplate] = createReusableTemplate()

defineEmits(['itemClicked'])
</script>

<style scoped lang="scss">
a {
  color: unset;

  &:hover {
    text-decoration: none;
  }

  &:focus-visible {
    outline: rgb(16, 16, 16) solid 2px;
    outline-offset: 1px;
  }
}

.entity-item {
  cursor: pointer;
  padding: 1.2rem 1.2rem 1.2rem 2.4rem;
  border: 1px solid var(--color-dark-10);
  border-radius: 0.4rem;
  transition: background-color 100ms ease-in-out;

  &:hover {
    background-color: var(--color-primary-10);
  }

  &--background {
    border: none;
    border-radius: 0;
    background-color: var(--color-primary-10);

    &:hover {
      background-color: var(--color-primary-20);
    }
  }

  &__indicator {
    flex-shrink: 0;
  }
}
</style>
